import Vue from 'vue';

export function vVisible(el, binding) {
  const value = binding.value;

  if (value) {
    el.style.visibility = 'visible';
  } else {
    el.style.visibility = 'hidden';
  }
}

export default {
  install(vue, options) {
    Vue.directive('visible', vVisible);
  },
};
